import http from "@/api/http.js";

export async function getOrdersFromSource() {
  return await http
    .get("connector/update_orders")
    .then(res => {
      if (res) {
        const response = {
          status: "success",
          message: `Shipstation<br>${res.data.shipstation.totalResults} Orders found<br>${res.data.website.ordersInserted} New Inserted<br>Website<br>${res.data.website.totalResults} Orders found<br>${res.data.website.ordersInserted} New Inserted<br>${res.data.website.ordersUpdated} Orders updated`
        };
        return response;
      } else {
        return false;
      }
    })
    .catch(() => {
      return {
        status: "error",
        message: "Problem on request, contact Administrator"
      };
    });
}
export async function updateStores() {
  return await http.get("connector/update_shipstation_stores").then(res => {
    return res.data;
  });
}
